import InputCus from "../../Component/InputCus/Text/InputCus";
import { useEffect, useState } from "react";
import {
  SupplierFilterSupplier,
  SupplierDeleteSupplier,
  SupplierFilterSupplierType,
  CompanyManageMyCompany,
} from "../../Api/Services";
import imgDelete from "../../assets/Icon/icons8-remove-100.png";
import imgDoc from "../../assets/Icon/icons8-edit-48.png";
import { confirmAlert } from "react-confirm-alert";
import imgPlus from "../../assets/Icon/pluse.png";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Select from "../../Component/InputCus/Select/Select";
import StoreImg from "../../assets/Icon/logistics.png";
import BankImg from "../../assets/Icon/icons8-bank-64.png";

function Supplier() {
  const [Search, setSearch] = useState({});
  const [Data, setData] = useState([]);
  const [SupplierType, setSupplierType] = useState([]);
  const [myCompany, setMyCompany] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const navigate = useNavigate();

  const start = async () => {
    try {
      const SupplierFilterSuppliertData = await SupplierFilterSupplier({});
      if (
        SupplierFilterSuppliertData.status &&
        SupplierFilterSuppliertData.status === 200
      ) {
        setData(SupplierFilterSuppliertData.data.data.data);
        const SupplierFilterSupplierTypeData = await SupplierFilterSupplierType(
          {}
        );
        if (
          SupplierFilterSupplierTypeData.status &&
          SupplierFilterSupplierTypeData.status === 200
        ) {
          setSupplierType(SupplierFilterSupplierTypeData.data.data.data);
          const CompanyManageMyCompanyData = await CompanyManageMyCompany({});
          if (
            CompanyManageMyCompanyData.status &&
            CompanyManageMyCompanyData.status === 200
          ) {
            setMyCompany(CompanyManageMyCompanyData.data.data);
          }
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const Clear = async () => {
    setSearch({});
    setLoading(true);
    try {
      const SupplierFilterSupplierData = await SupplierFilterSupplier({});
      if (
        SupplierFilterSupplierData.status &&
        SupplierFilterSupplierData.status === 200
      ) {
        setData(SupplierFilterSupplierData.data.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const Searched = async () => {
    try {
      setLoading(true);
      const SupplierFilterSupplierData = await SupplierFilterSupplier({
        ...Search,
      });
      if (
        SupplierFilterSupplierData.status &&
        SupplierFilterSupplierData.status === 200
      ) {
        setData(SupplierFilterSupplierData.data.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const confirmDelete = (e) => {
    confirmAlert({
      title: "حذف مرجع",
      message: "آیا مطمئن هستید ؟",
      buttons: [
        {
          label: "بله",
          onClick: () => DeleteItem(e),
        },
        {
          label: "خیر",
        },
      ],
    });
  };

  const DeleteItem = async (e) => {
    try {
      setLoading(true);
      const SupplierDeleteSupplierData = await SupplierDeleteSupplier(e);
      if (
        SupplierDeleteSupplierData.status &&
        SupplierDeleteSupplierData.status === 200
      ) {
        toast.success("عملیات با موفقیت انجام شد");
        await start();
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const Add = () => {
    navigate("/Panel/Suppliers/Add");
  };

  const Edite = (id) => {
    navigate("/Panel/Suppliers/Edite/" + id);
  };

  const ShowStore = (id) => {
    navigate("/Panel/Suppliers/Warehouse/" + id);
  };
  const ShowBank = (id) => {
    navigate("/Panel/Suppliers/Bank/" + id);
  };

  const handleChangeSearch = (e) => {
    const newSearch = { ...Search };
    newSearch[e.target.id] = e.target.value;
    setSearch(newSearch);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
          <div className="d-flex justify-content-start align-items-center w-100 mb-5 pointer">
            <img
              onClick={() => {
                Add();
              }}
              src={imgPlus}
              alt=""
            />
            <div className="w-100 d-flex justify-content-end">
              <button
                onClick={() => {
                  navigate("/Panel/SuppliersType");
                }}
                className="m-2 border rounded-5 h6 ps-3 pe-3 pt-1 pb-2"
              >
                نوع
              </button>
            </div>
          </div>
          <div className="d-flex justify-content-start align-items-center flex-wrap">
            <InputCus
              type="text"
              name="name"
              id="name"
              text="نام"
              className="m-2"
              value={Search.name || ""}
              onChange={handleChangeSearch}
            />
            <InputCus
              type="text"
              name="description"
              id="description"
              text="توضیحات"
              className="m-2"
              value={Search.description || ""}
              onChange={handleChangeSearch}
            />
            <InputCus
              type="text"
              name="nationalId"
              id="nationalId"
              text="کد"
              className="m-2"
              value={Search.nationalId || ""}
              onChange={handleChangeSearch}
            />
            <InputCus
              type="text"
              name="symbol"
              id="symbol"
              text="سیمبل"
              className="m-2"
              value={Search.symbol || ""}
              onChange={handleChangeSearch}
            />
            <Select
              className="m-2"
              type="number"
              name="companyId"
              id="companyId"
              text="شرکت"
              value={Search.companyId || ""}
              onChange={handleChangeSearch}
              option={myCompany.map((item) => {
                let data = {
                  value: item.companyId,
                  title: item.companyName,
                };
                return data;
              })}
            />
            <Select
              className="m-2"
              type="number"
              name="supplierTypeId"
              id="supplierTypeId"
              text="نوع"
              value={Search.supplierTypeId || ""}
              onChange={handleChangeSearch}
              option={SupplierType.map((item) => {
                let data = {
                  value: item.id,
                  title: item.name,
                };
                return data;
              })}
            />
          </div>
          <div className="d-flex justify-content-between align-items-center w-100 mb-3">
            <div onClick={Searched} className="btnSearch">
              جست و جو
            </div>
            <div onClick={Clear} className="btnCancel">
              بروزرسانی
            </div>
          </div>
          <div className="d-flex justify-content-center align-items-center w-100 p-2 tableC">
            <table className="table">
              <thead className="sticky-header">
                <tr className="trTable">
                  <th>نوع</th>
                  <th>نام</th>
                  <th>سیمبل</th>
                  <th>کد</th>
                  <th>توضیحات</th>
                  <th>پدر</th>
                  <th>شرکت</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {Data.map((item, key) => (
                  <tr key={key}>
                    <td>{item.supplierTypeName}</td>
                    <td>{item.name}</td>
                    <td>{item.symbol}</td>
                    <td>{item.nationalId}</td>
                    <td>{item.description}</td>
                    <td>{item.parentName}</td>
                    <td>{item.companyName}</td>
                    <td className="td-actions">
                      <span
                        className="d-inline-block pointer ms-2"
                        tabIndex="0"
                        data-bs-toggle="tooltip"
                        title="حذف"
                      >
                        <img
                          height="30"
                          className="me-2"
                          src={imgDelete}
                          alt="حذف"
                          onClick={() => {
                            confirmDelete(item.id);
                          }}
                        />
                      </span>
                      <span
                        className="d-inline-block pointer"
                        tabIndex="0"
                        data-bs-toggle="tooltip"
                        title="ویرایش"
                      >
                        <img
                          height="30"
                          src={imgDoc}
                          alt="ویرایش"
                          onClick={() => {
                            Edite(item.id);
                          }}
                        />
                      </span>
                      <span
                        className="d-inline-block pointer me-2"
                        tabIndex="0"
                        data-bs-toggle="tooltip"
                        title="مراکز"
                      >
                        <img
                          height="40"
                          src={StoreImg}
                          alt="مراکز"
                          onClick={() => {
                            ShowStore(item.id);
                          }}
                        />
                      </span>
                      <span
                        className="d-inline-block pointer me-2"
                        tabIndex="0"
                        data-bs-toggle="tooltip"
                        title="بانک"
                      >
                        <img
                          height="40"
                          src={BankImg}
                          alt="بانک"
                          onClick={() => {
                            ShowBank(item.id);
                          }}
                        />
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Supplier;
